import React, { useEffect, useState } from 'react';
import { useListVals } from "../../Firebase/databaseHooks";
import { getDatabase, ref } from "firebase/database";
import Firebase from "../../Firebase/Firebase";
import { getAuth } from "firebase/auth";
import { MDBCol, MDBRow } from "mdbreact";
import { Card, Input, message, Table, Tree } from "antd";
import { Button } from "evergreen-ui";


const { Search } = Input;
var db = getDatabase(Firebase);
var auth = getAuth(Firebase);


const GroupPie = (props) => {


	const gData = [
		{
			key: "country",
			title: "Country",
			children: []
		},
		{
			key: "district",
			title: "District",
			children: []
		},
		{
			key: "organisation",
			title: "Organizations",
			children: []
		},
		{
			key: "groupType",
			title: "Group Type",
			children: []
		},
		{
			key: "responsibleUser",
			title: "Responsible User",
			children: []
		},
		/*
		{
				key: "other",
				title: "Other",
				children: [
						{
								key: "no. of women",
								title: "No. of Women"
						},
						{
								key: "no. of men",
								title: "No. of Men"
						}
				]
		}

		 */
	];

	const [groupArray] = useListVals(ref(db, "talmidsdb/Groups"))
	const [userArray] = useListVals(ref(db, "talmidsdb/users"));
	const [organizationArray] = useListVals(ref(db, "talmidsdb/organisations"));
	const [districtArray] = useListVals(ref(db, "talmidsdb/districts"));
	const [districts, setDistricts] = useState([]);
	const [orgs, setOrgs] = useState([]);
	const [countryArray] = useListVals(ref(db, "talmidsdb/Countries"));
	const [groupTypeArray] = useListVals(ref(db, "talmidsdb/GroupTypes"));
	const [expandedKeys, setExpandedKeys] = useState([]);
	const [autoExpandParent, setAutoExpandParent] = useState(true);
	const [searchValue, setSearchValue] = useState("");
	const [treeData, setTreeData] = useState(gData);
	const [treeData2, setTreeData2] = useState([]);
	const [checkedKeys, setCheckedKeys] = useState([]);
	const [selectedKeys, setSelectedKeys] = useState([]);
	const [checkedList, setCheckedList] = useState([]);
	const [loading, setLoading] = useState(false);
	const [columns, setColumns] = useState([]);
	const [tableData, setTableData] = useState([]);
	const [showModal, setShowModal] = useState(props.modal);


	useEffect(() => {
		setShowModal(props.modal);
		const userId = auth.currentUser;
		var role = userArray.find((user) => (user.id === userId))?.userRole;

		var orgArray = organizationArray?.map((org) => {
			var thisOrg = org;
			console.log(thisOrg)
			if (typeof thisOrg === 'object') {

				thisOrg.key = org.orgID;
				thisOrg.title = org.name;
				thisOrg.country = org.countryID;
				return thisOrg;
			}
		});
		setOrgs(orgArray);

		var useArray = userArray?.map((user) => {
			var thisUser = user;
			thisUser.key = user.id;
			thisUser.title = user.firstname + " " + user.surname;
			return thisUser;
		});

		var disArray = districtArray?.map((dis) => {
			var thisDis = dis;
			thisDis.key = dis.districtID;
			thisDis.title = dis.district;
			thisDis.country = dis.country
			return thisDis;
		});
		setDistricts(disArray);

		var countArray = countryArray?.map((count) => {
			var thisCount = count;
			thisCount.key = count.name + "-" + count.alpha3Code;
			thisCount.title = count.name;
			return thisCount;
		});

		var typeArray = groupTypeArray?.map((type) => {
			var thisType = type;
			thisType.key = type.typeID;
			thisType.title = type.type;
			return thisType;
		});

		gData?.map((item) => {
			item.key === "country" ? item.children = countArray : null;
			item.key === "organisation" ? item.children = orgArray : null;
			item.key === "district" ? item.children = disArray : null;
			item.key === "responsibleUser" ? item.children = useArray : null;
			item.key === "groupType" ? item.children = typeArray : null;

			return item;
		});

		setTreeData([...gData]);
		setTreeData2([...gData]);


	}, [countryArray, districtArray, groupTypeArray, organizationArray, userArray, props]);
	const dataList = [];
	const generateList = (data, depth = 0) => {
		if (depth > 10) return; // Prevent infinite recursion
		for (let i = 0; i < data.length; i++) {
			const node = data[i];
			const { key } = node;
			dataList.push({ key, title: key });
			if (node.children) {
				generateList(node.children, depth + 1);
			}
		}
	};
	generateList(gData);

	const getParentKey = (key, tree) => {
		let parentKey;
		for (let i = 0; i < tree.length; i++) {
			const node = tree[i];
			if (node?.children) {
				if (node?.children.some((item) => item?.key === key)) {
					parentKey = node?.key;
				} else if (getParentKey(key, node?.children)) {
					parentKey = getParentKey(key, node?.children);
				}
			}
		}
		return parentKey;
	};
	const onCheck = (checkedKeysValue, e) => {
		var key = e.node.key;
		var ifChecked = e.checked;
		var parentKey = getParentKey(key, treeData2);
		var alreadyChecked = e.halfCheckedKeys

		if ((parentKey === "country") && (alreadyChecked.includes("district") || alreadyChecked.includes("organisation"))) {
			message.error("Error: Wrong order of analysis. Start by selecting country first before selecting organisation or district!! ")
		}
		else {
			setCheckedKeys(checkedKeysValue);

			var existingKeys = checkedList;
			existingKeys = existingKeys.concat(checkedKeysValue);
			const uniqueArray = [];
			for (let i = 0; i < existingKeys.length; i++) {
				if (uniqueArray.indexOf(existingKeys[i]) === -1) {
					uniqueArray.push(existingKeys[i]);
				}
			}

			if (!ifChecked) {
				uniqueArray.splice(existingKeys.indexOf(key), 1);
			}

			setCheckedList([...uniqueArray]);

			// something else entirely

			var tempData = treeData2;

			console.log(e)
			var list = e.checkedNodesPositions.filter(x => x.pos.includes("0-0"));
			console.log(list);
			if (parentKey === "country" && list.length === 1) {
				console.log("there")
				console.log(key);
				if (e.checked) {
					tempData[1].children = districts.filter(child => (child.country === key));
					tempData[2].children = orgs.filter(child => child.country === key);
				} else {
					tempData[1].children = tempData[1].children.filter(child => (child.country !== key));
					tempData[2].children = tempData[2].children.filter(child => child.country !== key);
				}


			}
			if (parentKey === "country" && list.length > 1) {
				console.log(tempData[1].children);
				tempData[1].children = tempData[1].children.concat(districts.filter(child => (child.country === key)));
				tempData[2].children = tempData[2].children.concat(orgs.filter(child => (child.country === key)));
			}
			if (list.length === 0) {
				tempData[1].children = districts;
				tempData[2].children = orgs;
			}

			setTreeData(tempData);
		}


	};

	const onExpand = (expandedKeys) => {
		setExpandedKeys(expandedKeys);
		setAutoExpandParent(false);
	};

	const onChange = (e) => {
		const value = e.target.value?.toLowerCase();
		const expandedKeys = dataList
			?.map((item) => {
				if (item.title.indexOf(value) > -1) {
					return getParentKey(item.key, treeData2);
				}
				return null;
			})
			.filter((item, i, self) => item && self.indexOf(item) === i);
		if (value) {
			const hasSearchTerm = (n) => n.toLowerCase().indexOf(value) !== -1;
			const filterData = (arr) =>
				arr?.filter(
					(n) => hasSearchTerm(n.title) || filterData(n.children)?.length > 0
				);
			const filteredData = filterData(treeData2)?.map((n) => {
				return {
					...n,
					children: filterData(n.children)
				};
			});

			setTreeData(filteredData);
			setExpandedKeys(expandedKeys);
			setSearchValue(value);
			setAutoExpandParent(true);
		} else {
			setCheckedKeys(checkedList);
			setTreeData(treeData2);
			setExpandedKeys([]);
			setSearchValue("");
			setAutoExpandParent(false);
		}
	};

	const filterTreeNode = (node) => {
		const title = node.title.props.children[2];
		return title.indexOf(searchValue) !== -1;
	};

	const loop = (data, depth = 0) => {
		if (depth > 10) return []; // Prevent infinite recursion
		return data?.map((item) => {
			if (!item) return null; // Skip null or undefined items

			const index = item.title?.indexOf(searchValue);
			const beforeStr = item.title?.substr(0, index);
			const afterStr = item.title?.substr(index + searchValue.length);
			const title =
				index > -1 ? (
					<span>
						{beforeStr}
						<span className="site-tree-search-value">{searchValue}</span>
						{afterStr}
					</span>
				) : (
					<span>{item.title}</span>
				);

			if (item.children) {
				return { title, key: item.key, children: loop(item.children, depth + 1) };
			}

			return { title, key: item.key };
		}).filter(Boolean); // Remove null or undefined items
	};



	const onSelect = (selectedKeysValue, info) => {
		console.log('onSelect', info);
		setSelectedKeys(selectedKeysValue);
	};

	function filterUsers(users, filters) {
		return users.filter((user) => {
			return Object.entries(filters).every(([key, value]) => {
				if (!value) {
					return true; // filter not applied, pass the test
				}
				if (Array.isArray(value) && value.length > 0) {
					// check if any value in the array matches
					console.log(key)
					console.log(user)
					console.log(value)
					return value.some((arrayValue) => user[key] === arrayValue.key);
				}
				if (typeof value === 'object') {
					// check if all key-value pairs in the object match
					return Object.entries(value).every(([subKey, subValue]) => user[key][subKey] === subValue);
				}
				return user[key] === value; // check if user matches filter
			});
		});
	}


	const analyze = () => {

		var array = checkedList?.map((item) => { return getParentKey(item, treeData2) });
		if (!array.includes("country")) {
			message.error("Selecting a country is a minimum requirement. So please do so immediately!")
		} else {
			var keysArray = checkedList?.map((item) => {
				var parent = getParentKey(item, treeData2);
				var countryOf = ""
				if (parent === "district") {
					countryOf = districts?.find(x => x?.key === item)?.country;
					return {
						key: item,
						parent: parent,
						country: countryOf
					}
				} else if (parent === "organisation") {
					countryOf = orgs?.find(x => x?.key === item)?.country;
					return {
						key: item,
						parent: parent,
						country: countryOf
					}
				} else {
					return {
						key: item,
						parent: parent,
					}
				}

			});

			console.log(keysArray)
			keysArray = keysArray.filter(x => x.parent !== undefined);
			//there's probably a better way of implementing this!!!
			//create the column array required for the antd table object
			var columnArray = gData?.map((item) => {

				//console.log(keysArray.find(x => x.parent === item.key))
				if (keysArray.find(x => x.parent === item.key) !== undefined) {

					return item.key;
				}
			});

			// remove undefined elements in the array and then create dynamically the columns
			// based on the keys that have been selected
			//console.log(columnArray);
			columnArray = columnArray.filter(x => x !== undefined);


			columnArray = columnArray?.map((item, index) => {

				if (item.includes("other")) {
					return {
						title: item.split("-")[1]?.replace(/^./, item[1].toUpperCase()),
						dataIndex: item.split("-")[0] + "-" + index,
						key: item.split("-")[0] + "-" + index,
						render: (text, record) => (
							<div>
								{record.groups?.map((group, i) => (
									<div key={i}>{group[item.split("-")[0] + "-" + index]}</div>
								))}
							</div>
						),
					}
				} if (item.includes("country")) {
					return {
						title: item.replace(/^./, item[0].toUpperCase()),
						dataIndex: item,
						key: item
					}
				}
				else {
					return {
						title: item.replace(/^./, item[0].toUpperCase()),
						dataIndex: item,
						key: item,
						render: (text, record) => (
							<div>
								{record[item]?.map((itemObject, i) => (
									<div key={i}>{itemObject.key}<hr className="hr-dark my-2" /></div>
								))}
							</div>
						),
					}
				}

			});

			// adding the groups at the end is the default thing to do, since we're filtering groups
			columnArray.push({
				title: "Groups",
				dataIndex: "groups",
				key: "groups",
				render: (text, record) => (
					<div>
						{record.groups?.map((group, index) => (
							<div key={index}>
								{/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
								<a href="" onClick={(e) => {
									e.preventDefault();
									props.setGroup(group);
									props.setModal(true);
								}}>
									{group.groupName}
								</a>
								<hr className="hr-dark my-2" />
							</div>

						))}
					</div>
				),
			});


			setColumns(columnArray);

			console.log(keysArray);

			var countries = keysArray.filter(x => x.parent === "country");
			var dataArray = countries?.map((country) => {
				var datapoint = {}

				for (var i = 0; i < columnArray.length; i++) {
					datapoint[columnArray[i].key] = ""
				}
				var dis = keysArray.filter(x => x.parent === "district" && x.country === country.key);
				var res = keysArray.filter(x => x.parent === "responsibleUser");
				var org = keysArray.filter(x => x.parent === "organisation" && x.country === country.key);
				var type = keysArray.filter(x => x.parent === "groupType");

				datapoint.country = country.key;
				datapoint.district = dis;
				datapoint.organisation = org;
				datapoint.groupType = type;
				datapoint.responsibleUser = res;
				datapoint.groups = filterUsers(groupArray, { groupType: type, country: country.key, district: dis, organisation: org, responsibleUser: res })

				console.log(datapoint);

				return datapoint;

			})

			console.log(dataArray);
			dataArray = dataArray?.map((item) => {
				item.country = countryArray.find(x => (x.label + "-" + x.alpha3Code) === item.country)?.label;

				item.district.length > 0 ? item.district = item.district?.map(y => {
					y.key = districtArray.find(x => x.districtID === y.key).district;
					return y;
				}) : null;

				item.groupType.length > 0 ? item.groupType = item.groupType?.map(y => {
					y.key = groupTypeArray.find(x => x.groupType === y.key).name;
					return y;
				}) : null;

				item.organisation.length > 0 ? item.organisation = item.organisation?.map(y => {
					y.key = organizationArray.find(x => x.orgID === y.key).name;
					return y;
				}) : null;

				item.responsibleUser.length > 0 ? item.responsibleUser = item.responsibleUser?.map(y => {
					y.key = userArray?.find(x => x?.id === y.key)?.firstname
						+ " " + userArray?.find(x => x?.id === y.key)?.surname;
					return y;
				}) : null;

				return item;
			})
			setTableData(dataArray);
		}



	}


	return (
		<div className="h-100">
			<MDBRow>
				<MDBCol md={"3"}>
					<div className="h-100">
						<Card className="h-100">
							<div className="d-flex flex-column">
								<Search
									style={{
										marginBottom: 8,
									}}
									placeholder="Search"
									onChange={onChange}
								/>
								<Tree
									checkable
									selectable={false}
									onExpand={onExpand}
									expandedKeys={expandedKeys}
									autoExpandParent={autoExpandParent}
									treeData={loop(treeData)}
									filterTreeNode={filterTreeNode}
									onCheck={onCheck}
									checkedKeys={checkedKeys}
									onSelect={onSelect}
									selectedKeys={selectedKeys}
								/>

								<div className="d-flex align-self-end mt-5">
									<Button appearance="primary" className="mx-1" onClick={() => { analyze() }}>
										Update
									</Button>
								</div>

							</div>

						</Card>

					</div>
				</MDBCol>

				<MDBCol>
					<div className="h-100">
						<Card className="h-100">
							<Table style={{ overflow: "auto" }} loading={loading}
								bordered
								pagination={{ defaultPageSize: 100, showSizeChanger: true, pageSizeOptions: ['20', '50', '100'] }}
								id={"dataTable"} dataSource={tableData} columns={columns} />
						</Card>
					</div>
				</MDBCol>
			</MDBRow>

		</div>
	)
}

export default GroupPie;
